import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-video-preview" }
const _hoisted_2 = {
  class: "login-video-preview__video",
  autoplay: "",
  ref: "video"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "login-video-preview__wave" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "login-video-preview__state label-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", _hoisted_2, null, 512),
    _hoisted_3,
    (_ctx.stateMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.stateMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}